"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DonutChart = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var d3 = tslib_1.__importStar(require("d3"));
var isEqual_1 = tslib_1.__importDefault(require("lodash/fp/isEqual"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var noop_1 = tslib_1.__importDefault(require("lodash/fp/noop"));
var chartUtils_1 = require("../chartUtils");
var ChartContainer_1 = require("../ChartContainer");
var Slice_1 = require("./Slice");
var DonutChart = (function (_super) {
    tslib_1.__extends(DonutChart, _super);
    function DonutChart(props) {
        var _this = _super.call(this, props) || this;
        _this.createAttributes = _this.createAttributes.bind(_this);
        _this.onChartResize = _this.onChartResize.bind(_this);
        var _a = _this.props, _b = _a.marginRight, marginRight = _b === void 0 ? 100 : _b, _c = _a.marginBottom, marginBottom = _c === void 0 ? 46 : _c;
        _this.chartMargin = {
            left: 0,
            right: marginRight,
            top: 0,
            bottom: marginBottom,
        };
        _this.state = {
            chartWidth: 0,
            chartHeight: 0,
            donutSize: 0,
        };
        return _this;
    }
    DonutChart.prototype.componentDidMount = function () {
        this.createAttributes();
    };
    DonutChart.prototype.onChartResize = function (newWidth, newHeight) {
        var _a = this.state, chartWidth = _a.chartWidth, chartHeight = _a.chartHeight, donutSize = _a.donutSize;
        var newWidthWithMargin = chartUtils_1.getChartWidthWithMargin(newWidth, this.chartMargin);
        var newHeightWithMargin = chartUtils_1.getChartHeightWithMargin(newHeight, this.chartMargin);
        var dimensionToUse = chartHeight >= chartWidth ? chartWidth : chartHeight;
        var newDonutSize = dimensionToUse / 2;
        if (donutSize === 0) {
            this.setState({ donutSize: newDonutSize });
        }
        if (!isEqual_1.default(newWidthWithMargin, chartWidth) ||
            !isEqual_1.default(newHeightWithMargin, chartHeight)) {
            this.setState({
                chartWidth: newWidthWithMargin,
                chartHeight: newHeightWithMargin,
                donutSize: newDonutSize,
            });
            this.createAttributes();
        }
    };
    DonutChart.prototype.createAttributes = function () {
        var chartMargin = this.chartMargin;
    };
    DonutChart.prototype.render = function () {
        var _this = this;
        var _a = this.props, colorScale = _a.colorScale, data = _a.data, _b = _a.showLabels, showLabels = _b === void 0 ? true : _b, _c = _a.hideChartHeader, hideChartHeader = _c === void 0 ? false : _c;
        var _d = this.state, chartHeight = _d.chartHeight, chartWidth = _d.chartWidth, donutSize = _d.donutSize;
        var chartMargin = this.chartMargin;
        var innerRadius = donutSize / 1.8;
        var outerRadius = donutSize;
        var createPie = d3.pie().value(function (d) { return d.percent; });
        var format = d3.format('.0f');
        var arc = d3
            .arc()
            .outerRadius(outerRadius * 0.9)
            .innerRadius(innerRadius * 0.8);
        var outerArc = d3
            .arc()
            .outerRadius(outerRadius * 1.3)
            .innerRadius(innerRadius * 0.9);
        var pointerArc = d3
            .arc()
            .outerRadius(outerRadius * 1.4)
            .innerRadius(innerRadius);
        var labelArc = d3
            .arc()
            .outerRadius(outerRadius * 1.5)
            .innerRadius(innerRadius);
        var getAlignment = function (d) {
            var angle = labelArc.centroid(d)[1];
            if (angle > 1) {
                return 'hanging';
            }
            if (angle < -1) {
                return 'baseline';
            }
            return 'middle';
        };
        var getAnchor = function (d) {
            var angle = labelArc.centroid(d)[0];
            if (angle > 0) {
                return 'start';
            }
            return 'end';
        };
        var chartData = createPie(data);
        var svgWidth = chartUtils_1.getSVGWidth(chartWidth, chartMargin);
        var svgHeight = chartUtils_1.getSVGHeight(chartHeight, chartMargin);
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(ChartContainer_1.ChartContainer, { zoomable: false, onChartResize: this.onChartResize, tagsLegendColorScale: noop_1.default, tagsLegendData: [{}], hideChartHeader: hideChartHeader },
                react_1.default.createElement("svg", { ref: function (el) { return (_this.SVGElement = el); }, width: svgWidth, height: svgHeight },
                    react_1.default.createElement("g", { transform: "translate(" + svgWidth / 2 + ", " + svgHeight / 2 + ")", ref: function (el) { return (_this.DonutChart = el); } }, chartData.map(function (datum, i) { return (react_1.default.createElement("g", null,
                        react_1.default.createElement(Slice_1.Slice, { data: datum, color: colorScale(datum, i), arc: arc }),
                        showLabels && (react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement(StyledLabelLine, { stroke: "black", strokeWidth: 1, x1: outerArc.centroid(datum)[0], y1: outerArc.centroid(datum)[1], x2: pointerArc.centroid(datum)[0], y2: pointerArc.centroid(datum)[1] }),
                            react_1.default.createElement(StyledLabel, { textAnchor: getAnchor(datum), transform: "translate(" + labelArc.centroid(datum) + ")", fill: "black", fontSize: 12, alignmentBaseline: getAlignment(datum) }, format(datum.value) + "%"))))); }))))));
    };
    return DonutChart;
}(react_1.PureComponent));
exports.DonutChart = DonutChart;
var StyledLabelLine = styled_components_1.default.line(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject([""], [""])));
var StyledLabel = styled_components_1.default.text(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject([""], [""])));
var templateObject_1, templateObject_2;
